module.exports = __webpack_public_path__ + "static/img/929_phase_function_Paper_Points.97f46c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/929_phase_function_Paper_Points.png
// module id = igAr
// module chunks = 0